import { createContext, ReactNode } from 'react'

import { BannerType } from 'components/Banner'
import { noop } from '@sketch/utils'
import { BannersMap } from './BannersMap.types'

type BannerId = keyof BannersMap

export interface BannerParameters {
  dismissible?: boolean
  onDismiss?: () => void
  message: ReactNode
  type?: BannerType
  id?: BannerId
}

export interface BannerItem {
  id: BannerId
  message: React.ReactNode
  type: BannerType
  dismissible: boolean
}

const bannerContext = createContext({
  items: [] as BannerItem[],
  showBanner: (parameters: BannerParameters) => ({
    dismissBanner: noop,
  }),
  dismissBanner: (id: BannerId) => {},
})

export default bannerContext
